export default __webpack_public_path__ + "static/media/ninguem.12142473.png";